import React from "react";

export default function Innovative() {
  return (
    <div className="agn-innovative-wrapper">
      <style>{`
  s
        .agn-innovative-wrapper {
          padding: var(--section-padding);
          background: #ffffff;
          position: relative;
          overflow: hidden;
        }

        .agn-innovative-wrapper::before {
          content: '';
          position: absolute;
          width: 400px;
          height: 400px;
          background: radial-gradient(circle, rgba(var(--theme-color-rgb), 0.05) 0%, transparent 70%);
          bottom: -10%;
          left: -10%;
          z-index: 0;
        }

        .innovative-container {
          position: relative;
          z-index: 1;
        }

        .innovative-title h2 {
          font-family: var(--font-primary);
          font-size: var(--h2-size);
          font-weight: var(--h2-weight);
          letter-spacing: -0.03em;
          line-height: var(--lh-tight);
          margin-bottom: 40px;
          color: var(--theme-color);
          position: relative;
          display: inline-block;
        }

        .innovative-title h2::after {
          content: '';
          position: absolute;
          bottom: -12px;
          left: 0;
          width: 60px;
          height: 3px;
          background: var(--theme-color);
          border-radius: 2px;
        }

        .innovative-list {
          display: flex;
          flex-direction: column;
          gap: 15px;
          padding: 0;
          list-style: none;
        }

        .innovative-item {
          background: #ffffff;
          border: 1px solid rgba(0, 0, 0, 0.04);
          padding: 18px 25px;
          border-radius: 18px;
          display: flex;
          align-items: center;
          gap: 18px;
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.02);
        }

        .innovative-item:hover {
          transform: translateX(10px) scale(1.01);
          border-color: rgba(var(--theme-color-rgb), 0.2);
          box-shadow: 0 12px 25px rgba(var(--theme-color-rgb), 0.08);
        }

        .innovative-tick {
          width: 38px;
          height: 38px;
          background: rgba(var(--theme-color-rgb), 0.1);
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          transition: all 0.3s ease;
        }

        .innovative-item:hover .innovative-tick {
          background: var(--theme-color);
          transform: rotate(10deg);
        }

        .innovative-tick img {
        filter: brightness(0) saturate(100%) invert(75%) sepia(21%) saturate(769%) hue-rotate(346deg) brightness(90%) contrast(88%);
          width: 16px;
          transition: all 0.3s ease;
        }

        .innovative-item:hover .innovative-tick img {
          filter: brightness(0) invert(1);
        }

        .innovative-text {
          font-family: var(--font-secondary);
          font-size: var(--small-size);
          font-weight: 500;
          color: #222;
          margin: 0;
          line-height: var(--lh-base);
        }

        .innovative-image-wrapper {
          position: relative;
          padding: 20px;
        }

        .innovative-image-wrapper::before {
          content: '';
          position: absolute;
          top: 0;
          right: 0;
          width: 100%;
          height: 100%;
          border: 2px dashed rgba(var(--theme-color-rgb), 0.2);
          border-radius: 40px;
          z-index: -1;
          transform: rotate(3deg);
        }

        .innovative-img {
          border-radius: 30px;
          box-shadow: 0 30px 60px rgba(0, 0, 0, 0.12);
          transition: transform 0.6s ease;
          width: 100%;
        }

        .innovative-image-wrapper:hover .innovative-img {
          transform: rotate(-2deg) scale(1.02);
        }

        @media (max-width: 991px) {
          .innovative-title h2 {
            text-align: center;
            display: block;
          }
          .innovative-title h2::after {
            left: 50%;
            transform: translateX(-50%);
          }
          .innovative-image-wrapper {
            margin-top: 50px;
          }
        }
      `}</style>

      <section className="innovative-section">
        <div className="container innovative-container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="innovative-content">
                <div className="innovative-title">
                  <h2>AGN Unlocks Multiple Financial Advantages
                  </h2>
                </div>

                <ul className="innovative-list">
                  <li className="innovative-item">
                    <div className="innovative-tick">
                      <img src="../assets/svg/home/tick.svg" width="16" alt="tick" />
                    </div>
                    <span className="innovative-text">
                      Earn recurring income through structured asset participation

                    </span>
                  </li>

                  <li className="innovative-item">
                    <div className="innovative-tick">
                      <img src="../assets/svg/home/tick.svg" alt="tick" />
                    </div>
                    <span className="innovative-text">
                      Access both long-term and short-term earning plans

                    </span>
                  </li>

                  <li className="innovative-item">
                    <div className="innovative-tick">
                      <img src="../assets/svg/home/tick.svg" alt="tick" />
                    </div>
                    <span className="innovative-text">
                      Utilize idle capital efficiently

                    </span>
                  </li>

                  <li className="innovative-item">
                    <div className="innovative-tick">
                      <img src="../assets/svg/home/tick.svg" alt="tick" />
                    </div>
                    <span className="innovative-text">
                      Benefit from network-driven incentives

                    </span>
                  </li>

                  <li className="innovative-item">
                    <div className="innovative-tick">
                      <img src="../assets/svg/home/tick.svg" alt="tick" />
                    </div>
                    <span className="innovative-text">
                      Participate without technical trading expertise

                    </span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="innovative-image-wrapper">
                <img
                  src="assets/images/img/agn_unlocks.png"
                  className="innovative-img"
                  alt="Financial Advantages"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
